import React, { useState } from "react";
import { ArrowRightLeft } from "lucide-react";

export default function CurrencyConverter() {
  const [jpy, setJpy] = useState("");
  const [rate, setRate] = useState(0.2); // 預設匯率，可讓使用者自己改

  return (
    <div className="flex flex-col h-[70vh] justify-center items-center space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-starbucks">即時換算</h2>
        <div className="flex items-center justify-center gap-2 mt-2 text-sm text-gray-400">
          <span>匯率:</span>
          <input
            type="number"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            className="w-16 bg-gray-800 text-center border-b border-gray-600 focus:outline-none"
          />
        </div>
      </div>

      <div className="w-full bg-white text-black p-8 rounded-3xl shadow-2xl relative">
        <div className="space-y-6">
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase">
              JPY (日圓)
            </label>
            <input
              type="number"
              value={jpy}
              onChange={(e) => setJpy(e.target.value)}
              className="w-full text-4xl font-mono font-bold border-b-2 border-gray-200 py-2 focus:outline-none focus:border-starbucks placeholder-gray-300"
              placeholder="0"
            />
          </div>

          <div className="flex justify-center -my-2">
            <div className="bg-starbucks text-white p-2 rounded-full shadow-lg">
              <ArrowRightLeft size={20} />
            </div>
          </div>

          <div>
            <label className="text-xs font-bold text-gray-500 uppercase">
              TWD (台幣)
            </label>
            <div className="text-4xl font-mono font-bold text-starbucks py-2">
              {jpy ? Math.round(jpy * rate).toLocaleString() : "0"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
